import { preloadRovoChatIdentity } from '@confluence/fabric-media-support/entry-points/preloadRovoChatIdentity.ts';
import { expValEquals } from '@confluence/feature-experiments';
import { ssrPrepareErrorsClient } from '@confluence/ssr-utilities/entry-points/SSRPrepareErrorsClient.ts';

/** Preload the default Rovo agent identity into Relay for synchronous mention rendering. */
export async function preloadRovoChatMentionIdentity(cloudId?: string): Promise<void> {
	if (!cloudId || !expValEquals('platform_editor_mention_rovo', 'isEnabled', true)) {
		return;
	}

	try {
		await preloadRovoChatIdentity(cloudId);
	} catch (cause) {
		ssrPrepareErrorsClient.submitError(
			new Error('Failed to preload Rovo mention identity', { cause }),
		);
	}
}
